<template>
  <div class="GlobalFormDemo">
    <GlobalForm :init-data="initData" :form-item-list="formItemList" :inline="true" :labelWidth="90" round :needBtnLoading="true"
      @handleConfirm="handleConfirm" confirmBtnName="查询">

      <el-form-item class="el_from" label="回收商家" slot="operationSelect" style="margin:0">
        <el-select v-model="merchantId" placeholder="请选择商家" filterable clearable>
          <el-option v-for="item in shanpsSelectList" :key="item.merchantId" :label="item.merchantName"
            :value="item.merchantId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="el_from" label="所属门店" slot="operationSelect" style="margin:0">
        <el-select v-model="companyId" placeholder="请选择门店" filterable clearable>
          <el-option v-for="item in merchantSelectList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>



      <el-form-item class="el_from" label="物流单号" slot="expressNo" style="margin:0">
        <el-input v-model="expressNo" placeholder="请输入物流单号查询" clearable>
        </el-input>
      </el-form-item>

      <!-- <el-form-item class="el_from" label="所属门店" slot="operationSelect">
        <el-select
          v-model="storeId"
          placeholder="请先选择所属门店"
          :disabled="isHasCompany"
          filterable
          clearable
        >
          <el-option
            v-for="item in storeList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item> -->


      <div slot="AddSlot">
        <el-button size="small" type="success" icon="el-icon-download" :loading="exportLoading" @click="clickExcel">导出Excel</el-button>
      </div>
    </GlobalForm>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from 'moment'
export default {
  name: "Form",
  props: {
    accountType: {
      require: true,
      type: String
    },
  },
  data() {
    return {
      expressNo: '',
      arrssy: {},
      pickerMinDate: null,
      pickerMaxDate: null,
      day31: 30 * 24 * 3600 * 1000,
      merchantId: "",
      initData: {
        entryTime: [moment().day(moment().day() - 6).format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')]
      },
      formItemList: [
        { slotName: 'operationSelect' },
        {
          key: "staffName",
          type: "input",
          labelName: "发货人",
          placeholder: "请输入门店员工姓名",
        },
        //     {
        //   key: "expressNo",
        //   type: "input",
        //   labelName: "物流单号",
        //   placeholder: "请输入物流单号查询",
        // },
        { slotName: 'expressNo' },
        {
          key: 'state',
          type: 'select',
          lableWidth: '100',
          labelName: '物流状态',
          option: [
            {
              value: '2',
              label: '运输中',
            },
            {
              value: '6',
              label: '已完成'
            },
            {
              value: '7',
              label: '已取消',
            },

          ],
        },
        {
          key: 'expressCode',
          type: 'select',
          labelName: '发货快递',
          option: [
            {
              value: 'jd',
              label: '京东'
            },
            {
              value: 'shunfeng',
              label: '顺丰',
            },

          ],
        },
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "时间",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && this.pickerMinDate) {
                this.pickerMinDate = null;
              } else if (minDate) {
                this.pickerMinDate = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              if (this.pickerMinDate) {
                return (
                  time.getTime() > this.pickerMinDate + this.day31 ||
                  time.getTime() < this.pickerMinDate - this.day31
                );
              }
              return false;
            },
          },
        },



      ],
      merchantSelectList: [],
      storeList: [],
      isHasCompany: true,
      storeId: '',
      shanpsSelectList: [],
      companyId: '',
      exportLoading: false
    };
  },
  created() {
    _api.listSimpleMerchantView().then((res) => {
      if (res.code === 1) {
        this.shanpsSelectList = res.data
      }
    })

    _api.getStoreSelectOrder().then((res) => {
      if (res.code === 1) {
        this.merchantSelectList = res.data
      }
    })

    let expressNo = this.$route.query.id;
    console.log(expressNo);
    if (expressNo) {
      this.expressNo = expressNo;
    }

    this.handleConfirm();


    let startTime = moment()
      .day(moment().day() - 6)
      .format("YYYY-MM-DD 00:00:00"); // 当前时间往前推15天的时间
    let endTime = moment().format("YYYY-MM-DD 23:59:59");
    startTime = Date.parse(startTime);
    endTime = Date.parse(endTime);
    this.entryTime = [startTime, endTime];

  },
  watch: {
    companyId(newVal) {
      console.log(newVal);
      if (newVal != '') {
        this.isHasCompany = false
      } else {
        this.storeId = ''
        this.isHasCompany = true
      }
    }
  },
  methods: {

    clickExcel() {

      var arr = Object.keys(this.arrssy);
      var len = arr.length;

      if (!len) {
        this.arrssy = { pageNum: 1, pageSize: 10, startTime: this.entryTime[0], endTime: this.entryTime[1], };
        console.log(this.arrssy);
      }

      this.exportLoading = true
      _api.excelexpressorder(this.arrssy).then(res => {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "物流信息.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      }).finally(() => {
            this.exportLoading = false;
          })
    },
    //    handleChangeInquiry(val) {
    //   console.log(val)
    //   this.companyId = val
    //   if(val != ''){
    //     this.storeId = ''
    //     this.getStoreSelectList()
    //   }
    // },
    // 获取门店列表
    getStoreSelectList() {
      _api.getStoreSelectList({ companyId: this.companyId }).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.storeList = res.data
        }
      })
    },
    handleConfirm(data,cd) {
      let SeachParams = {};
      if (data) {
        let startTime = ""
        let endTime = ""
        if (data.entryTime === null) {
          (startTime = ''), (endTime = '')
        } else {
          (startTime = moment(data.entryTime[0]).format("x")),
            (endTime = moment(data.entryTime[1]).format("x"))
        }

        SeachParams = {
          merchantId: this.merchantId,
          storeId: this.companyId,
          expressNo: this.expressNo,
          staffName: data.staffName,
          state: data.state,
          startTime: startTime,
          endTime: endTime,
          pageNum: 1,
          pageSize: 10,
          expressCode: data.expressCode
        };
      }
      this.arrssy = JSON.parse(JSON.stringify(SeachParams));
      SeachParams.disuseLoding = () => {
        if (typeof cd === 'function') {
          cd()
        }
      },
      console.log(SeachParams);
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {}
</style>
